import { strToEl } from 'data/function';
const loadingElementId = 'global-loading';
const loadingTemplate = `
<div class="global-loading flex items-center justify-center zindex-loading"
    id="${loadingElementId}">
    <bds-illustration type="brand" name="blip-ballon-white" class="pulse-large animated duration-1-5s infinite">
    </bds-illustration>
</div>
`;
export class LoadingService {
    constructor() {
        'ngInject';
        this.loading = false;
        const loadingTemplateHtml = strToEl(loadingTemplate);
        this.startLoading = (local = true) => {
            this.loading = true;
            this.local = local;
            try {
                !this.local && window.document.body.appendChild(loadingTemplateHtml);
            }
            finally {
                return;
            }
        };
        this.stopLoading = () => {
            this.loading = false;
            try {
                document.body.removeChild(loadingTemplateHtml);
                const loadingElement = document.getElementById(loadingElementId);
                if (loadingElement) {
                    loadingElement.style.display = 'none';
                }
            }
            finally {
                return;
            }
        };
        this.isLoadingGlobal = () => this.loading && !this.local;
        this.isLoadingLocal = () => this.loading && this.local;
    }
}
